import { NgModule } from '@angular/core';
import { PersistenceService } from '../services/persistence.service';
/**
 * The module for the persistence framework.  This will register the PersistenceService
 * as a provider and export it.
 *
 * @export
 * \@class AngularPersistenceModule
 *
 * @author Scott O'Bryan
 * \@since 1.0
 */
import * as ɵngcc0 from '@angular/core';
export var PersistenceModule = (function () {
    function PersistenceModule() {
    }
    /** @nocollapse */
    PersistenceModule.ctorParameters = function () { return []; };
PersistenceModule.ɵfac = function PersistenceModule_Factory(t) { return new (t || PersistenceModule)(); };
PersistenceModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PersistenceModule });
PersistenceModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [PersistenceService] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PersistenceModule, [{
        type: NgModule,
        args: [{
                providers: [PersistenceService]
            }]
    }], function () { return []; }, null); })();
    return PersistenceModule;
}());
function PersistenceModule_tsickle_Closure_declarations() {
    /** @type {?} */
    PersistenceModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    PersistenceModule.ctorParameters;
}

